import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { PromiseResult } from "../models/PromiseResult";
import {
    CosnultationDataQuery,
    appointmentGetQuery,
    getPatientTimingsQuery,
    appointmentCreate,
    appointmentUpdate,
    Appointment_close_otp,
    AppointmentClose,
    AppointmentInitiate,
    AppointmentZoom,
    AssignDoctorModel,
    ReassignDoctorModel,
    RescheduleDoctorModel,
    updateSpeciality,
    CosnultationHistoryDataQuery,
    Sort_Data,
    consent_close
} from "../models/appointment";
import { RestApi } from "../shared/apiUrls";

@Injectable({
    providedIn: "root",
})
export class AppointmentService {
    constructor(private readonly http: HttpClient) { }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    GetAllMyAssignedPatients(query: appointmentGetQuery): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.AppointmentApi + "fetch", query)
            .pipe(
                catchError(this.handleError)
            )
    }

    GetPatientTimings(query: getPatientTimingsQuery): Observable<PromiseResult> {
        const params = new HttpParams()
            .append("user_guid", query.user_guid)
            .append("patient_guid", query.patient_guid)
            .append("consultation_id", query.consultation_id.toString());
        return this.http.get<PromiseResult>(RestApi.Urls.AppointmentApi + "Get/time", { params: params })
            .pipe(
                catchError(this.handleError)
            )
    }

    Create(data: appointmentCreate): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.AppointmentApi + "Create", data)
            .pipe(
                catchError(this.handleError)
            )
    }

    Update(user_guid: string, data: appointmentUpdate): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.AppointmentApi + "Update/" + user_guid, data)
            .pipe(
                catchError(this.handleError)
            )
    }

    otp_verify(user_guid: string, data: Appointment_close_otp): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.AppointmentApi + "action/" + user_guid + "/send/otp", data)
            .pipe(
                catchError(this.handleError)
            )
    }

    Assign(assign: AssignDoctorModel): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.AppointmentApi + "Assign", assign)
            .pipe(
                catchError(this.handleError)
            )
    }

    Reassign(reassign: ReassignDoctorModel): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.AppointmentApi + "reassign", reassign)
            .pipe(
                catchError(this.handleError)
            )
    }

    Reschedule(reschedule: RescheduleDoctorModel): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.AppointmentApi + "reschedule", reschedule)
            .pipe(
                catchError(this.handleError)
            )
    }

    GetAllUnassignedPatients(sort: Sort_Data): Observable<PromiseResult> {
        const params = new HttpParams()
            .append("order_by", sort.sort_selected)
        return this.http.get<PromiseResult>(RestApi.Urls.AppointmentApi + "Get/New", { params: params })
            .pipe(
                catchError(this.handleError)
            )
    }

    InitiateAppointment(user_guid: string, data: AppointmentInitiate): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.AppointmentApi + "action/" + user_guid + "/initiate", data)
            .pipe(
                catchError(this.handleError)
            )
    }

    ZoomAppointmentUrl(user_guid: string, data: AppointmentZoom): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.AppointmentApi + "action/" + user_guid + "/meeting_url", data)
            .pipe(
                catchError(this.handleError)
            )
    }

    CloseAppointment(user_guid: string, data: AppointmentClose): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.AppointmentApi + "action/" + user_guid + "/close", data)
            .pipe(
                catchError(this.handleError)
            )
    }
    getCosnultationData(data: CosnultationDataQuery): Observable<PromiseResult> {
        const params = new HttpParams()
            .append("user_guid", data.user_guid)
            .append("patient_guid", data.patient_guid)
            .append("consultation_id", data.consultation_id.toString());
        return this.http.get<PromiseResult>(RestApi.Urls.AppointmentApi + "Get/full", { params: params })
            .pipe(
                catchError(this.handleError)
            )

    }


    updateSpecialty(data: updateSpeciality): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.AppointmentApi + "update/specialty", data)
            .pipe(
                catchError(this.handleError)
            )
    }

    UpdateConsent(consultation_id: number, data:consent_close): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.AppointmentApi + "update/consent/" + consultation_id, data)
            .pipe(
                catchError(this.handleError)
            )
    }

    getCosnultationHistory(data: CosnultationHistoryDataQuery): Observable<PromiseResult> {
        const params = new HttpParams()
            .append("user_guid", data.user_guid)
            .append("patient_guid", data.patient_guid)
            .append("consultation_id", data.consultation_id.toString());
        return this.http.get<PromiseResult>(RestApi.Urls.AppointmentApi + "Get/history", { params: params })
            .pipe(
                catchError(this.handleError)
            )

    }
}
